export const BASE = 'https://back.sferafarma.cloud/'
export const API = 'api/v1/'
export const URL_BASE = BASE + API
export const FARMACLOUD_URL = 'https://accounts.farmacloud.io/sso/areaprivada-prod?login='

// export const BACK_SFERAFARMA = 'https://accounts.farmacloud.io/'
// PROD : https://back.sferafarma.cloud/
// DEV : https://back-sferafarma.enpreproduccion.com/
